
export class MessageDialogOptions {
    width: string;
    height: string;
    maxHeight: string;
    closable = true;

    constructor (props: Partial<MessageDialogOptions> = null) {
        if (props != null) {
            Object.assign(this, props);
        }
    }
}
